import { useCallback, useState } from 'react';

import { MessageSource, ThinkingSource } from './webSearch.types';

export const useWebSearch = () => {
  const [streamingThinkingSources, setStreamingThinkingSources] = useState<ThinkingSource[]>([]);
  const [streamingSources, setStreamingSources] = useState<MessageSource[]>([]);

  const onThinkingSource = useCallback((source: ThinkingSource) => {
    setStreamingThinkingSources((prev) => (prev.some((s) => s.url === source.url) ? prev : [...prev, source]));
  }, []);

  const onSources = useCallback((sources: MessageSource[]) => {
    setStreamingSources(sources);
  }, []);

  const reset = useCallback(() => {
    setStreamingThinkingSources([]);
    setStreamingSources([]);
  }, []);

  return { streamingThinkingSources, streamingSources, onThinkingSource, onSources, reset };
};
